import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import EditStates from "../EditStates";
import StatesDelete from "./StatesDelete";
import CustomTooltip from "../../../common/CustomTooltip";

const StatesActionButton = ({ id, statesModal }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showStates, setShowStates] = useState(false);

  const toggleStatesModal = () => {
    showStates && statesModal();

    setShowStates(!showStates);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };
  return (
    <>
      <span>
        {/* <FontAwesomeIcon
          onClick={toggleShowModal}
          icon={faEye}
          size="1x"
          data-toggle="modal"
          data-target="#clientDetail"
        /> */}
        {/* <span></span>&nbsp;&nbsp;/&nbsp;&nbsp; */}
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={toggleStatesModal}
            />
          </span>
        </CustomTooltip>
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <CustomTooltip message={"Delete"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleDeleteModal}
              icon={faTrash}
              size="1x"
              data-toggle="modal"
              data-target="#deleteClient"
            />
          </span>
        </CustomTooltip>
      </span>

      {showDelete && (
        <StatesDelete
          statesId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={statesModal}
          showDelete={showDelete}
        />
      )}

      {showStates && (
        <EditStates
          statesId={id}
          showStates={showStates}
          toggleStatesModal={toggleStatesModal}
        />
      )}

      {/* {showView && (
        <StatesDetailPopup
          showView={showView}
          statesId={id}
          toggleShowModal={toggleShowModal}
        />
      )} */}
    </>
  );
};

export default StatesActionButton;
